import { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import "../../styles/components/forms.css";
import "../../styles/user/login.css";
import axios from "axios";

const Login = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait for loading to complete, then redirect if user is authenticated
    if (!loading && user) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/login`,
        credentials,
        { withCredentials: true }
      );
      const data = response.data;
      if (data.success) {
        setSuccess(data.message);
        setError("");
        // Let AuthContext handle the user state
        await login(data.user);
        navigate("/dashboard", { replace: true });
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response?.data?.message || "Innlogging feilet");
    }
  };

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Laster...</p>
      </div>
    );
  }

  // If user is already authenticated, show loading while redirecting
  if (user) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Omdirigerer til dashboard...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="login-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Logg inn</h2>
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
          <input
            type="email"
            placeholder="Epost"
            value={credentials.email}
            onChange={(e) =>
              setCredentials({ ...credentials, email: e.target.value })
            }
          />
          <input
            type="password"
            placeholder="Passord"
            value={credentials.password}
            onChange={(e) =>
              setCredentials({ ...credentials, password: e.target.value })
            }
          />
          <div className="forgot-password-link">
            <Link to="/forgot-password">Glemt passord?</Link>
          </div>
          <button type="submit">Logg inn</button>
          <Link className="create-account-link" to="/create-account">
            Opprett konto
          </Link>
        </form>
      </div>
    </div>
  );
};

export default Login;
